import React from 'react';
import LazyTable from 'app/component/lazy-table';
import { Checkbox } from 'primereact/checkbox';

const AssistantTable: React.FC = () => {
  const showCheckbox = isOn => {
    return <Checkbox disabled={true} style={{ marginLeft: '1rem' }} checked={isOn as boolean} />;
  };

  return LazyTable({
    initialSortField: 'id',
    createUrl: '/create-assistant',
    labelForCreateEntity: 'Vytvoriť asistenta',
    serverUrl: '/api/assistants',
    editActionAllowed: true,
    searchAllowed: false,
    globalFilterFields: ['businessName', 'firstName', 'lastName', 'email'],
    columns: [
      { field: 'activated', header: 'Aktivovaný', sortable: true, formatter: showCheckbox },
      { field: 'firstName', header: 'Prvé meno', sortable: true },
      { field: 'lastName', header: 'Priezvisko', sortable: true },
      { field: 'email', header: 'Email', sortable: true },
    ],
  });
};

export default AssistantTable;
